<ng-container *ngIf="crimeGunService.nibinCaseData$ | async as case">
  <section *ngIf="!showFullComment">
    <h2>NIBIN Case Data</h2>
    <div class="card mb-3">
      <div class="card-body">
        <div class="row gy-2 gx-3 align-items-center m-2">
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Case #:</div>
          <div class="col-lg-8 col-md-7">{{ case.LabCaseNumber }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">LE Case #:</div>
          <div class="col-lg-8 col-md-7">
            <ng-container *ngIf="!!case.LECaseNumber;else nibincase">
              <button type="button" class="btn btn-link p-0" aria-label="{{'View LE case number '+case.LECaseNumber+' details'}}" (click)="showDetails.emit({ detailType: searchResultType.RMSEvent, dataId: case.EventID })">{{ case.LECaseNumber }}</button>
            </ng-container>
            <ng-template #nibincase>{{ case.NIBINLECaseNumber }}</ng-template>
          </div>
          <div class="col-lg-4 col-md-5 text-start text-md-end"> NIBIN Case LE Agency Contact:</div>
          <div class="col-lg-8 col-md-7">{{ case.OriginatingAgencyContact }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Occurrence Date:</div>
          <div class="col-lg-8 col-md-7">{{ case.OccurrenceDate | date:'MM/dd/yyyy' }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Crime Type:</div>
          <div class="col-lg-8 col-md-7">{{ case.EventType }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Site:</div>
          <div class="col-lg-8 col-md-7">{{ case.SiteCodeShortName }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Case Creator:</div>
          <div class="col-lg-8 col-md-7">{{ case.NIBINCreationUser }}</div>
          <div class="col-lg-4 col-md-5  text-start text-md-end">NIBIN Case Comments:</div>
          <div class="col-lg-8 col-md-7">
            <ng-container *ngIf="!!case.Comments;else nocomments">
              {{ case.Comments | shortenText: 1000 }} <ng-container *ngIf="case.Comments?.length > 1000"><button type="button" class="btn btn-link px-0 d-block" (click)="showFullCommentText({ 'headerText': case.LabCaseNumber, 'commentText': case.Comments})">[Show full NIBIN case comment]</button></ng-container>
            </ng-container>
            <ng-template #nocomments>No comment(s) provided.</ng-template>
          </div>
        </div>
      </div>
    </div>
    <p-table [value]="case['PiecesOfEvidence']" [columns]="cols" [rows]="rows" [paginator]="true" [alwaysShowPaginator]="false" [autoLayout]="true" responsiveLayout="scroll" styleClass="mb-3">
      <ng-template pTemplate="caption">
        <div class="p-2 fw-bold text-center">All Pieces of Evidence (POEs)</div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-poe let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns;let first=first;" [ngSwitch]="col.field">
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'CaliberCode'">{{ getCaliberEvidenceCategory(poe) }}</td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'ManufacturerCode'" class="text-center">
              <ng-container *removeIfNoPermission="canEditCrimeGun; else viewonly">
                <button *ngIf="poe && !!poe['FirearmID'];else nohyperlink" class="btn btn-link px-0" aria-label="{{'View crime gun information'}}" (click)="showDetails.emit({ detailType: searchResultType.FirearmData, dataId: poe.FirearmID})">{{ getFirearmObject(poe)}}</button>
              </ng-container>
              <ng-template #viewonly>
                <ng-container *removeIfNoPermission="canViewCrimeGun; else nohyperlink">
                  <button *ngIf="poe && !!poe['FirearmID'];else nohyperlink" class="btn btn-link px-0" aria-label="{{'View crime gun information'}}" (click)="showDetails.emit({ detailType: searchResultType.FirearmData, dataId: poe.FirearmID })">{{ getFirearmObject(poe)}}</button>
                </ng-container>
              </ng-template>
              <ng-template #nohyperlink>{{ getFirearmObject(poe) }}</ng-template>
            </td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'ReceptionDate'">{{ poe['ReceptionDate'] | date:'MM/dd/YYYY' | emptyTextTransform:'N/A'}}</td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'AcquisitionTime'">{{ poe['AcquisitionTime'] | date:'MM/dd/YYYY'}}</td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'Comments'"><ng-container *ngIf="!!poe.Comments;else nopoecomments">{{ poe['Comments'] | shortenText: 100 }}<ng-container *ngIf="poe.Comments?.length > 100"><button type="button" class="btn btn-link px-0 d-block" (click)="showFullCommentText({ 'headerText': poe.ExhibitReferenceNumber, 'commentText': poe.Comments})">[Show full POE comment]</button></ng-container></ng-container><ng-template #nopoecomments>No comment(s) provided.</ng-template></td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'FirearmComment'"><ng-container *ngIf="!!poe.FirearmComment;else nofacomments">{{ poe['FirearmComment'] | shortenText: 100 }}<ng-container *ngIf="poe.FirearmComment?.length > 100"><button type="button" class="btn btn-link px-0 d-block" (click)="showFullCommentText({ 'headerText': getFirearmObject(poe), 'commentText': poe.FirearmComment})">[Show full firearm comment]</button></ng-container></ng-container><ng-template #nofacomments>No comment(s) provided.</ng-template></td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'Removed'">{{ poe.Removed | booleanTransform}} <ng-container *ngIf="poe.Removed">- {{ poe.DateRemoved | date:'MM/dd/YYYY'}}</ng-container></td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'CrimeGunNumber'">
              <ng-container *ngIf="!!poe['CrimeGunNumber'];else nocrimegun">
                <a (click)="openRelatedCrimeGun($event, poe.CrimeGunNumberID)">{{poe.CrimeGunNumber}}</a> <span *ngIf="poe.IsCrimeGunRecovered" aria-hidden="true" class="icon-crime-gun"></span><span *ngIf="poe.IsCrimeGunRecovered" class="visually-hidden">Crime gun recovered.</span>
              </ng-container>
              <ng-template #nocrimegun>N/A</ng-template>
            </td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'NIBINCreationUser'">
              <ng-container *ngIf="!!poe['NIBINCreationUser'];else noAcquisitionTech">
                {{poe['NIBINCreationUser']}}
              </ng-container>
              <ng-template #noAcquisitionTech>N/A</ng-template>
            </td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchCase="'FirearmAcquisitionTech'">
              <ng-container *ngIf="!!poe['FirearmAcquisitionTech'];else noFirearmAcquisitionTech">
                {{poe['FirearmAcquisitionTech']}}
              </ng-container>
              <ng-template #noFirearmAcquisitionTech>N/A</ng-template>
            </td>
            <td [attr.scope]="first ? 'row' : ''" *ngSwitchDefault>{{ poe[col.field] }}</td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No POEs found.
          </td>
        </tr>
      </ng-template>
    </p-table>
    <button type="button" (click)="showNIBINCaseData.emit(false)" class="btn btn-active mb-3">Close</button>
  </section>
  <ng-container *ngIf="targetComment$ | async as comment">
    <section *ngIf="showFullComment" class="m-3">
      <h2>Comment for {{ comment.headerText }}</h2>
      <p class="mb-3">{{ comment.commentText }}</p>
      <button type="button" (click)="showFullComment = false; targetComment.next(null);" class="btn btn-active">Close</button>
    </section>
  </ng-container>
</ng-container>
